// extracted by mini-css-extract-plugin
export var compactFilters = "_gi-4";
export var detailImage = "_gi-1";
export var dropdownContainer = "_gi-2";
export var imageContainer = "_gi-0";
export var selectedCard = "_gi-3";